import React, { useState } from 'react';
import { Typography, TextField, Box, FormControlLabel, Checkbox, Button, Stack, Drawer } from '@mui/material';
import { theme } from '../../../theme';
import DrawerHeader from '../../CustomComponents/DrawerHeader';

function DraftNotesDrawer({ open, onClose, draft, submitChanges, logUserAction }) {

    const maxChars = 2000;
    const [notes, setNotes] = useState(draft?.physician_notes || '');
    const [deleteCard, setDeleteCard] = useState(!!draft?.is_card_marked_for_deletion);

    const handleNotesChange = (e) => {
        setNotes(e.target.value);
    };

    const handleDeleteCardChange = (e) => {
        setDeleteCard(e.target.checked);
    };

    const onSave = async () => {
        await submitChanges({
            draftId: draft.id,
            physicianNotes: notes,
            isCardMarkedForDeletion: deleteCard
        });
        logUserAction({ action: 'saved_draft_notes', data: { draftId: draft.id } });
    };

    const disableSave = notes === (draft?.physician_notes || '') && deleteCard === !!draft?.is_card_marked_for_deletion;

    const textboxProps = {
        notes,  
        maxChars,
        deleteCard,
        disableSave,
        onSave,
        handleNotesChange,
        handleDeleteCardChange,
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { width: { xs: '100%', sm: '75%', md: '50%' }, maxWidth: '600px' } }}
        >
            <DrawerHeader handleBack={onClose} title="Notes to Staff" />
            <Stack backgroundColor={theme.palette.background.categoryDrawer} spacing={2} p={2} height='100%' >
                <DraftNotesTextField {...textboxProps} />
            </Stack>
        </Drawer>
    )
}

function DraftNotesTextField({ notes, handleNotesChange, maxChars, deleteCard, handleDeleteCardChange, onSave, disableSave }) {

    return  (
        <Box sx={{ backgroundColor: theme.palette.background.white, boxShadow: 2, borderRadius: 2, px: 2, position: 'relative', pb: 7 }}>
            <TextField
                fullWidth
                multiline
                minRows={2}
                maxRows={6}
                mt={0}
                value={notes}
                onChange={handleNotesChange}
                placeholder={'Leave comments or feedback for the staff who will be reviewing these changes after you...'}
                variant="outlined"
                margin="normal"
                inputProps={{ maxLength: maxChars }}
                helperText={`${notes.length}/${maxChars} characters`}
            />
            <Box sx={{ pl: 2, pb: 2 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={deleteCard}
                            onChange={handleDeleteCardChange}
                        />
                    }
                    label={<Typography variant="caption" fontSize={14}>Request deactivation of this card</Typography>}
                />
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 2 }}>
                    Selecting this option will let the card manager know that you want to deactivate this card in the case that you no longer perform procedures of this type.
                </Typography>
            </Box>
            <Button
                variant="blueContained"
                sx={{ position: 'absolute', bottom: 16, right: 16 }}
                onClick={onSave}
                disabled={disableSave}
            >
                {disableSave ? 'Saved' : 'Save'}
            </Button>
        </Box>
    );
}

export default DraftNotesDrawer;